import { BlockPage } from '@labrav/common'

const FUNDING_PREVIEW_IMAGES = [
  'https://assets.flyout.labra.io/misc/first.png',
  'https://assets.flyout.labra.io/misc/second.png',
  'https://assets.flyout.labra.io/misc/third.png',
]

const REQUEST_ACCESS_URL = 'https://helpcenter.labra.io/hc/en-us/requests/new'

const FUNDING_FEATURES = [
  'Maximize your funding potential by identifying every eligible funding opportunity with AI-powered insights.',
  'Automate the entire funding workflow; from drafting and submitting requests to tracking approvals and follow-ups.',
  'Get funds faster as the AI Funding Agent manages the process until the funding is deposited into your bank account.',
]

export const FundingBlockPage = () => (
  <BlockPage
    title="Your plan does not include Labra AI Suite."
    features={FUNDING_FEATURES}
    buttonText="Request to enable"
    buttonHref={REQUEST_ACCESS_URL}
    images={FUNDING_PREVIEW_IMAGES}
    imageAlt="Funding management preview"
  />
)

export default FundingBlockPage
